import BN from '../node_modules/bignumber.js'

export const BIG_ZERO = new BN(0)
export const BIG_ONE = new BN(1)
export const BIG_TWO = new BN(2)
export const BIG_NINE = new BN(9)
export const BIG_TEN = new BN(10)
export const BIG_ONE_HUNDRED = new BN(100)

export const bigIntToSerializedBigNumber = (bigint: bigint): string => bigIntToBigNumber(bigint).toJSON()

export const bigIntToBigNumber = (bigint: bigint): BN => new BN(bigint.toString())

export const bigNumberToBigInt = (bigNumber: BN): bigint => BigInt(bigNumber.toString())

export const BigNumber = BN
